import $ from 'jquery';

const defaults = {
  selector: '#next_slide',
};

function NextSlide(element, options) {
  this.$element = $(element);
  this.settings = Object.assign(defaults, options);
  this.click = this.click.bind(this);
  this.listen();
}

NextSlide.prototype = {
  listen() {
    this.$element.find(this.settings.selector).on('click', this.click);
  },
  click() {
    $(this.$element.find('.slick-next')).click();
    return false;
  },
};

export default NextSlide;
